import HeroHeading from "@/components/sections/hero/HeroHeading";
import HeroActions from "@/components/sections/hero/HeroActions";
import HeroStats from "@/components/sections/hero/HeroStats";

export default function HeroContent({ t, scrollTo }) {
  const { hero } = t;
  return (
    <div className="lg:col-span-7 reveal">
      <HeroHeading
        eyebrow={hero.eyebrow}
        titleA={hero.titleA}
        titleB={hero.titleB}
        titleC={hero.titleC}
      />
      <p className="mt-8 text-lg sm:text-xl max-w-xl text-[var(--body)] leading-relaxed">
        {hero.subtitle}
      </p>
      <HeroActions
        ctaPrimary={hero.ctaPrimary}
        ctaSecondary={hero.ctaSecondary}
        scrollTo={scrollTo}
      />
      <HeroStats stats={hero.stats} />
    </div>
  );
}
